/** @type {string} */
const carouselString = "carousel";
export default carouselString;
